import { createSlice } from '@reduxjs/toolkit'

let newState

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userAccount: null,
    isLogged: false,
    isLogging: false,
    isWax: false,
    isAnchor: false,
    status: 'LOGGED_OUT',
  },
  reducers: {
    getWaxUser() {
      return {
        type: 'LOGIN_USER_WAX',
      }
    },
    getAnchorUser() {
      return {
        type: 'LOGIN_USER_ANCHOR',
      }
    },
    setUser(state, action) {
      switch (action.payload.type) {
        case 'GET_USER':
          newState = {
            ...state,
            isLogging: true,
            status: 'LOGIN_IN',
            error: '',
          }
          return newState
        case 'LOGIN_SUCCESS':
          newState = {
            ...state,
            isWax: action.payload.isWax,
            isAnchor: action.payload.isAnchor,
            userAccount: action.payload.userAccount,
            accountName: action.payload.userAccount.accountName,
            isLogged: true,
            isLogging: false,
            status: 'LOGGED_IN',
          }
          return newState
        case 'LOGIN_ERROR':
          newState = {
            ...state,
            isLogged: false,
            accountName: undefined,
            userAccount: undefined,
            isWax: false,
            isAnchor: false,
            hasError: true,
            errorMessage: action.payload.error.message,
            status: 'LOGIN_ERROR',
          }
          return newState
        case 'LOGIN_CANCELLED':
          newState = {
            ...state,
            status: 'LOGIN_CANCELLED',
            accountName: undefined,
            userAccount: undefined,
            isLogged: false,
            isLogging: false,
          }
          return newState
        default:
          break
      }
      // const userData = action.payload;
      // return { ...state, ...userData };
    },
  },
})

export const { getWaxUser, getAnchorUser, setUser } = userSlice.actions

export default userSlice.reducer
